import React from 'react';

function CurrencyToggle({ currency, onChange }) {
  return (
    <div className="currency-toggle">
      <button
        className={`currency-btn ${currency === 'USD' ? 'active' : ''}`}
        onClick={() => onChange('USD')}
      >
        USD $
      </button>
      <button
        className={`currency-btn ${currency === 'NOK' ? 'active' : ''}`}
        onClick={() => onChange('NOK')}
      >
        NOK kr
      </button>
    </div>
  );
}

export default CurrencyToggle;
